import { render, staticRenderFns } from "./SummaryCardGeneral.vue?vue&type=template&id=63457485&"
import script from "./SummaryCardGeneral.vue?vue&type=script&lang=js&"
export * from "./SummaryCardGeneral.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/components/views/dashboard/members/id/partial/cards/summary-card-general.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports